module.exports = __webpack_public_path__ + "static/media/me.5007685e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/me.jpg
// module id = 254
// module chunks = 2